import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/authStore';

import HomePage from '../views/HomePage.vue';
import LoginRegisterPage from '../views/LoginRegisterPage.vue';
import UiKit from '@/views/UiKit.vue';
import MainLayout from '@/components/layout/MainLayout.vue';
import TestPage from '@/views/TestPage.vue';
import UserAccountPage from '@/views/UserAccountPage.vue';
import UserRankingPage from '@/views/UserRankingPage.vue';
import ActivateAccountPage from '@/views/ActivateAccountPage.vue';
import ActivationInfo from '@/views/ActivationInfo.vue';
import ResetPasswordPage from '@/views/ResetPasswordPage.vue';
import WealthCalculatorPage from '@/views/WealthCalculatorPage.vue';
import BuyRanking from '@/views/BuyRanking.vue';
import LegalNoticePage from '@/views/LegalNoticePage.vue';
import PrivacyPolicyPage from '@/views/PrivacyPolicyPage.vue';
import TermsOfUsePage from '@/views/TermsOfUsePage.vue';
import TermsOfSalePage from '@/views/TermsOfSalePage.vue';

const routes = [
    {
        path: '/',
        component: MainLayout,
        children: [
            {
                path: '',
                redirect: { name: 'Home' } // redirige "/" vers "/home"
            },
            {
                path: 'home',
                name: 'Home',
                component: HomePage
            },
            {
                path: 'account',
                name: 'UserAccount',
                component: UserAccountPage,
                meta: { requiresAuth: true }

            },
            {
                path: 'ranking',
                name: 'UserRanking',
                component: UserRankingPage,
                meta: { requiresAuth: true }
            },
            {
                path: 'calculateur-richesse',
                name: 'WealthCalculator',
                component: WealthCalculatorPage
            },
            {
                path: 'buy-ranking',
                name: 'BuyRanking',
                component: BuyRanking,
                meta: { requiresAuth: true }
            },
        ]
    },
    {
        path: '/login-register',
        name: 'LoginRegister',
        component: LoginRegisterPage
    },
    {
        path: '/ui-kit',
        name: 'UiKit',
        component: UiKit
    },
    {
        path: '/test',
        name: 'Test',
        component: TestPage
    },
    {
        path: '/activate',
        name: 'ActivateAccount',
        component: ActivateAccountPage
    },
    {
        path: '/activation-info',
        name: 'ActivationInfo',
        component: ActivationInfo
    },
    {
        path: '/reset-password',
        name: 'ResetPassword',
        component: ResetPasswordPage
    },
    {
        path: '/mentions-legales',
        name: 'LegalNotice',
        component: LegalNoticePage
    },
    {
        path: '/politique-confidentialite',
        name: 'PrivacyPolicy',
        component: PrivacyPolicyPage
    },
    {
        path: '/cgu',
        name: 'TermsOfUse',
        component: TermsOfUsePage
    },
    {
        path: '/cgv',
        name: 'TermsOfSale',
        component: TermsOfSalePage
    },
]

const router = createRouter({
    scrollBehavior() {
        return { top: 0 }
    },
    history: createWebHistory('/'),
    routes
})

// Garde de navigation globale
router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore();

    // Si l'utilisateur n'est pas encore chargé, tenter de le charger
    if (to.path !== '/login-register' && authStore.user === null && to.meta.requiresAuth) {
        try {
            await authStore.fetchUser();
        } catch (error) {
            console.error("Erreur lors du chargement de l'utilisateur:", error);
        }
    }

    if (to.meta.requiresAuth && !authStore.isLoggedIn) {
        if (to.path !== '/login-register') {
            console.log('User not authenticated, redirecting to login');
            return next('/login-register');
        }

    }

    if (to.path === '/login-register' && authStore.isLoggedIn) {
        console.log('User already authenticated, redirecting to home');
        return next('/home');
    }

    next();

});


export default router